import { useTranslator } from '@bluebeam/react-i18n';
import InputSelect from 'components/inputs/SearchInput';
import React, { useState } from 'react';
import { RFI } from 'records/RFI';
import { RFIQuery } from 'records/RFIQuery';
import queryRFIs from 'utils/queryRFIs';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import PostRFIListItem from './PostRFIListItem';

interface Props extends WithAppStoreProps {
  onRFIClick: (selectedRFI: RFI) => void;
  selectedRFI: RFI | null;
}

const PostRFIList = (props: Props): React.ReactElement => {
  const [query, setQuery] = useState(new RFIQuery());
  const { appState, selectedRFI, onRFIClick } = props;
  const { rfis, roles, markups, sheets } = appState;
  const queriedRFIs = queryRFIs(rfis, roles, markups, sheets, query);
  const { translate } = useTranslator(['mapView', 'buttons']);

  const qRFIs = queriedRFIs
    .map((rfi) => rfi)
    .filter((rfi: RFI): boolean => {
      if (
        rfi.craeteddate === 0 ||
        (rfi.versionnumber === 0 && rfi.answer === null)
      ) {
        return false;
      }

      return true;
    })
    .groupBy((item) => item.get('id').split('+')[0]);

  const handleSearchChange = (searchStr: string) => {
    setQuery((prevQuery) => prevQuery.set('search', searchStr));
  };

  return (
    <>
      <div>
        <div className="row justify-between items-center mx4 mb3">
          <div>
            {translate('mapView:postRFIList.approvedRFIs')} ({qRFIs.size})
          </div>
          <div>
            <InputSelect
              id="post-rfi-list-search-input"
              placeholder={translate('buttons:search')}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>
      <div
        className="grow-1 bgd-mid-grey-1 mx4 oa bt-2 br-2 bl-2"
        style={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
        }}
      >
        {qRFIs.toList().map((rfi) => {
          const currentRfi: RFI = rfi.last();

          return (
            <PostRFIListItem
              key={currentRfi.id}
              rfi={currentRfi}
              selectedRFI={selectedRFI}
              onRFIClick={onRFIClick}
            />
          );
        })}
      </div>
    </>
  );
};

export default withAppStore<Props>(PostRFIList);
